export default class SaveDepotWorkRequest {
    public warehouseId: string = "";
    
    public hours: number = 0;
    
    public date: Date = new Date();
    
    public comment: string = "";
    
    public workOrderTypeId: string | null = null;
    
    public managerId: string = "";

    public constructionSiteId: string = "";
}
